import { Col, Row } from 'react-bootstrap';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { forwardRef, useEffect } from 'react';
import { AppConst } from 'consts';
import BorderBottom from './BorderBottom';

const MintSection = forwardRef<HTMLDivElement, {}>((props, ref) => {
	const [inViewRef, inView] = useInView({
		delay: AppConst.InViewDelay,
		rootMargin: AppConst.InViewMargin,
	});

	const controls = useAnimation();

	useEffect(() => {
		if (inView) {
			controls.start('visible');
		} else {
			controls.start('hidden');
		}
	}, [controls, inView]);

	return (
		<div className="mint" ref={ref}>
			<Row
				className="parallax"
				style={{
					backgroundImage: 'url("./static/image/nft-mtg.png")',
				}}
			>
				<Col xs={12} sm={12} md={12} lg={12} xl={3} className="mint-text" ref={inViewRef}>
					<motion.div
						className="mint-content"
						animate={controls}
						initial="hidden"
						variants={{
							hidden: { opacity: 0, transition: { duration: 1 } },
							visible: { opacity: 1 },
						}}
						transition={{ type: 'spring', duration: 5 }}
					>
						<h2 className="color-white">Mint your MTG today</h2>
						<p className="color-white pt20">
							Do Not miss out on this Drop, 10,000 Gamers will be available for minting at 0.1 ETH
							with ( x amount) of whitelist spots reserved at 0.09 eth
						</p>
						<BorderBottom />
					</motion.div>
				</Col>
				{/* <Col xs={12} sm={12} md={12} lg={12} xl={9}></Col> */}
			</Row>
		</div>
	);
});

export default MintSection;
